import { Event } from '@mui/icons-material';
import { Grid, Paper, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';

export default function DateOfDeliveryCard({ dateOfDelivery }) {
	return (
		<Paper
			elevation={3}
			sx={{
				width: '100%',
				height: '100%',
				backgroundColor: 'white.main',
				borderRadius: '8px',
				padding: '8px',
				display: 'flex',
			}}
		>
			<Grid
				container
				sx={{ justifyContent: 'space-evenly', alignItems: 'center' }}
			>
				<Grid
					item
					xs={2}
					xsm={2}
					sx={{ textAlign: { xs: 'start', xsm: 'center' } }}
				>
					<Event />
				</Grid>
				<Grid item xs={10} xsm={6}>
					<Typography fontWeight='bold'>Fecha de entrega</Typography>
					<Typography>
						{dayjs(dateOfDelivery).format('DD/MM/YYYY HH:mm')}
					</Typography>
				</Grid>
				<Grid
					item
					xs={12}
					xsm={4}
					sx={{ textAlign: { xs: 'end', xsm: 'end' } }}
				>
					<Typography>
						Restan {dayjs(dateOfDelivery).diff(Date.now(), 'day')} dias
					</Typography>
				</Grid>
			</Grid>
		</Paper>
	);
}
